export default "__VITE_ASSET__CwMu5iHA__"